import { NextPage } from 'next'
import { FaSearch } from 'react-icons/fa'
import InfiniteScroll from 'react-infinite-scroller'
import { LoadingSpinner } from 'web_core/assets/spinners'
import { UserList } from 'web_core/assets/user/List'
import { useQueryData } from 'web_core/hooks'
import { useESUsers } from 'web_core/hooks/models'
import { isBlank } from 'web_core/utils'
import { makeLocaleStaticProps } from 'web_core/utils/static_props'
import { DefaultLayout } from '~/components/Layout/Default'
import { Heading } from '~/components/Utils/Heading'
import { SearchNavSelector } from '~/components/Utils/SearchNavSelector'
import { useLayoutProperty } from '~/context/layout_property'
import { userSearchBreadcrumb } from '~/utils'

export const getStaticProps = makeLocaleStaticProps

const Page: NextPage = () => {
  const keyword = useQueryData('keyword')
  const { users, loadMore, isReachingEnd, isLoadingMore } = useESUsers(
    !isBlank(keyword) && keyword !== ''
      ? {
          type: 'query',
          locale: 'ja',
          keyword,
        }
      : null
  )
  const title =
    !isBlank(keyword) && keyword !== ''
      ? `「${keyword}」に関連するユーザ`
      : 'ユーザの検索'
  const description =
    !isBlank(keyword) && keyword !== ''
      ? `「${keyword}」に関連するユーザの一覧を閲覧できます。`
      : 'Mathlogのユーザ検索ページです。キーワードを入力して目的のユーザを見つけましょう。'

  const { headerHeight } = useLayoutProperty()

  return (
    <DefaultLayout
      head={{ title, description, keyword: keyword ?? undefined }}
      navLinks={{ pc: true, tablet: true, sp: true }}
      categoriesMenu={{ pc: true }}
      leftSidebar
      rightSideBar
    >
      {userSearchBreadcrumb.toReactNode()}
      <Heading title={title} icon={FaSearch} />
      <div
        className="sticky-top bg-white pt-2 pb-2 mb-2 mb-md-4"
        style={{ top: headerHeight }}
      >
        <SearchNavSelector
          active="users"
          link="/[target]"
          keyword={keyword}
          className="mb-2 mb-md-4"
        />
      </div>
      {!isBlank(keyword) && keyword !== '' ? (
        <InfiniteScroll
          loadMore={async () => {
            if (isLoadingMore === false && isReachingEnd === false)
              await loadMore()
          }}
          hasMore={isReachingEnd === false}
          loader={<LoadingSpinner />}
        >
          {users && (
            <UserList
              profiles={users}
              className="grid g-cols-1 g-lg-cols-2 small"
            />
          )}
        </InfiniteScroll>
      ) : (
        <p>検索キーワードを入力してください。</p>
      )}
    </DefaultLayout>
  )
}

export default Page
